var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHomeWhite = function SvgHomeWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "43px",
    viewBox: "0 0 41 43",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, ">\n    ", _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1111114,0 L0,15.4866312 L0,42.5882424 L13.6236561,42.5882424 L13.6236561,33.5543741 C13.6236561,29.9795434 16.5170612,27.1016111 20.1111114,27.1016111 C23.7051616,27.1016111 26.5985667,29.9795434 26.5985667,33.5543741 L26.5985667,42.5882424 L40.2222228,42.5882424 L40.2222228,15.4866312 L20.1111114,0 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomeWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home_white.9419e382.svg";
export { ForwardRef as ReactComponent };